import { render, staticRenderFns } from "./riskControlList.vue?vue&type=template&id=21c3cea4&scoped=true&"
import script from "./riskControlList.vue?vue&type=script&lang=ts&"
export * from "./riskControlList.vue?vue&type=script&lang=ts&"
import style0 from "./riskControlList.vue?vue&type=style&index=0&id=21c3cea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3cea4",
  null
  
)

export default component.exports